/**
 * KB-META
 * Purpose: Analytics HTTP interceptor to add x-trace-id and emit api.* details
 * Role: ui.service
 */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AnalyticsService } from '../services/analytics.service';

@Injectable()
export class AnalyticsHttpInterceptor implements HttpInterceptor {
  constructor(private analytics: AnalyticsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip OPTIONS preflight and logger endpoint to avoid CORS issues and recursion
    const isOptions = req.method === 'OPTIONS';
    // Skip both /log and /logs on any stage
    const isLoggerEndpoint = /\/(dev|prod)\/logs?$|\/logs?$/i.test(req.url);
    const noTraceHeaderEndpoints = [
      '/partner/login',
      '/partner/refresh-token',
      '/partner/register',
      '/partner/forgot-password',
      '/partner/confirm-password',
      '/partner/set-new-password',
      '/partner/verify-mfa'
    ];
    const shouldSkipTraceHeader = noTraceHeaderEndpoints.some(p => req.url.includes(p));
    if (isOptions || isLoggerEndpoint) {
      return next.handle(req);
    }
    const startedAt = performance.now();
    const traceId = localStorage.getItem('traceId');
    const sameOrigin = this.isSameOrigin(req.url);
    const attachTrace = !!traceId && sameOrigin && !shouldSkipTraceHeader;
    const requestToHandle = attachTrace ? req.clone({ setHeaders: { 'x-trace-id': traceId } }) : req;
    const method = requestToHandle.method;
    const endpoint = this.stripQuery(requestToHandle.url);
    return next.handle(requestToHandle).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const durationMs = Math.round(performance.now() - startedAt);
            const statusCode = event.status;
            const serverRequestId = event.headers.get('x-request-id') || event.headers.get('x-amzn-requestid') || null;
            // Emit action for API call outcome
            const outcome = statusCode >= 400 ? 'ERROR' : 'SUCCESS';
            // this.analytics.trackAction('HTTP_CALL', this.analytics['deriveFeatureAreaFromRoute'](location.pathname), { route: location.pathname, component: null }, {
            //   api: { method, endpoint, statusCode, durationMs, serverRequestId },
            //   result: { outcome }
            // }).catch(() => {});
          }
        },
        error: (error: HttpErrorResponse) => {
          const durationMs = Math.round(performance.now() - startedAt);
          const statusCode = error.status || 0;
          const serverRequestId = error.headers?.get?.('x-request-id') || null;
          this.analytics.trackAction('HTTP_CALL', this.analytics['deriveFeatureAreaFromRoute'](location.pathname), { route: location.pathname, component: null }, {
            api: { method, endpoint, statusCode, durationMs, serverRequestId },
            result: { outcome: 'ERROR', message: error.message }
          }).catch(() => {});
        }
      })
    );
  }

  private stripQuery(url: string): string {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname;
    } catch {
      return url.split('?')[0];
    }
  }

  private isSameOrigin(url: string): boolean {
    try {
      const u = new URL(url, window.location.origin);
      return u.origin === window.location.origin;
    } catch {
      return false;
    }
  }
}


